import Project1 from './assets/project1.jpg';
import Project2 from './assets/project2.jpg';
import Project3 from './assets/project3.jpg';

export const links = [
  {
    name: 'Home',
    path: 'home',
    icon: 'home'
  },
  {
    name: 'Services',
    path: 'skills',
    icon: 'services'
  },
  {
    name: 'Projects',
    path: 'work',
    icon: 'projects'
  },
  {
    name: 'Experience',
    path: 'about',
    icon: 'experience'
  },
  {
    name: 'Connect',
    path: 'contact',
    icon: 'connect'
  },
];


export const services = [
  {
    id: 1,
    icon: "fullstack", // use for icon mapping
    title: "Full-Stack Development",
    services: [
      "End-to-end development of scalable web applications",
      "Building complete product flows from UI to database",
      "Designing clean APIs and integrating frontend with backend",
      "Developing role-based systems including admin dashboards",
      "Optimizing performance, security, and maintainability"
    ],
    skills: [
      "React",
      "JavaScript",
      "Node.js",
      "Express",
      "REST APIs",
      "PostgreSQL",
      "MongoDB",
      "Zustand"
    ]
  },
  {
    id: 2,
    icon: "frontend",
    title: "Frontend Engineering",
    services: [
      "Developing responsive and accessible user interfaces",
      "Building dashboards with charts, analytics, and visualizations",
      "Creating reusable components and scalable UI systems",
      "Implementing efficient state management and routing",
      "Enhancing user experience and frontend performance"
    ],
    skills: [
      "React",
      "JavaScript",
      "HTML",
      "CSS",
      "Chakra UI",
      "Tailwind CSS",
      "Nivo",
      "Zustand"
    ]
  },
  {
    id: 3,
    icon: "backend",
    title: "Backend & API Development",
    services: [
      "Designing secure and scalable backend architectures",
      "Building RESTful APIs for frontend and system integrations",
      "Database design, schema modeling, and query optimization",
      "Integrating third-party services like analytics and messaging",
      "Implementing authentication, authorization, and core logic"
    ],
    skills: [
      "Node.js",
      "Express",
      "PostgreSQL",
      "MongoDB",
      "REST APIs",
      "Authentication",
      "System Design"
    ]
  }
];

export const projects = [
  {
    id: 1,
    img: Project1,
    category: 'E-Commerce',
    title: 'Shoppers Prime',
    description:
      'A full-featured e-commerce platform with payment integration, user authentication, cart management, order processing, and an admin dashboard for managing users, products, and orders.',
    site: 'https://shoppers-prime.harshalrajput.com/',
  },
  {
    id: 2,
    img: Project2,
    category: 'Social Media',
    title: 'Sociopedia',
    description:
      'A scalable social media application built with the MERN stack, supporting user authentication, post creation and interaction, friend management, and real-time content engagement.',
    site: 'https://sociopedia.harshalrajput.com/',
  },
  {
    id: 3,
    img: Project3,
    category: 'E-Commerce',
    title: 'Bakingo',
    description:
      'A responsive cake delivery website developed using React, featuring reusable components, efficient state management, API integrations, and seamless form-based user interactions.',
    site: 'https://bakingo.harshalrajput.com/',
  },
];

export const cv = [
  {
    id: 1,
    title: 'Software Development Engineer- I at Pehchaan.me',
    date: 'July 2025 - Dec 2025',
    description: [
      'Enabled the Communication System by integrating WhatsApp (Wati), VoiceAI (Vodex) automating reminders and boosting candidate response rates by 45%.',
      'Integrated CleverTap for event tracking and journey automation, improving user re-engagement and reducing candidate drop-offs by 30%.',
      'Designed and implemented a Cheating Detection System using video analytics (face detection, head movement,tab-switch monitoring), enhancing integrity checks and increasing detection accuracy by 35%.'
    ],
    category: 'experience',
  },
  {
    id: 2,
    title: 'Full Stack Developer Intern at Pehchaan.me',
    date: 'Dec 2024 - June 2025',
    description: [
      'Revamped the Client Dashboard UI using React.js and Chakra UI, improving assessment navigation speed by 40% and integrating Nivo charts for real-time analytics.',
      'Built a complete Candidate Sourcing Pipeline, automating resume extraction from 3+ platforms (Naukri, Internshala, Indeed), reducing manual sourcing time by 70% and improving candidate relevance by 40%.',
      'Automated pre-screening and invitation flow, cutting manual effort by over 60%, and developed scalable APIs using Node.js and PostgreSQL, integrated with AI-powered assessments.',
    ],
    category: 'experience',
  },
  {
    id: 3,
    title: 'B-Tech in Computer Science & Engineering at IIIT Sonepat',
    date: 'Nov 2021 - June 2025',
    description: [
      'Graduated with a strong academic record, maintaining a CGPA of 9.13/10, reflecting consistent performance across core computer science subjects.',
      'Built a solid foundation in Data Structures, Algorithms, Database Systems, Operating Systems, and Software Engineering, complemented by hands-on project work.',
      'Recognized for all-round excellence, balancing academics with extracurricular achievements, including multiple gold medals in Snooker and Table Tennis during college fests.'
    ],
    category: 'education',
  },
];
